var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBattery4088Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Outlined_Blue_2_px",
    "data-name": "Icons Outlined Blue 2 px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .battery {\r\n                fill: currentcolor;\r\n            }\r\n        "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "battery",
    points: "26.25 17 20 28.08 24.68 28.08 21.77 37 28 25.93 23.32 25.93 26.25 17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "battery",
    d: "M29.22,4.51a24.19,24.19,0,0,0-10.44,0,1,1,0,0,0-.78,1V9H15a1,1,0,0,0-1,1V44a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1H30V5.48A1,1,0,0,0,29.22,4.51ZM20,6.3a22.4,22.4,0,0,1,8,0V9H20ZM32,11V43H16V11H32Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBattery4088Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/battery-40-88px.f9c065a9d1d9dc2ecab043e9d89b9c1e.svg";